// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__2fPgO","icon":"SortAdornment_icon__1oqAL","up":"SortAdornment_up__3sfVb","down":"SortAdornment_down__jChMT","active":"SortAdornment_active__S56ml"};